import { useRef } from "react"
import { useNavigate } from "react-router-dom"

import Style from "./style"

import DefaultButton from "shared/ui/DefaultButton"
import DefaultInput from "shared/ui/DefaultInput"

import useManagerLogin from "entity/auth/usePostManagerLogin"

const LoginManager = () => {
    const navigate = useNavigate()
    const idRef = useRef()
    const pwRef = useRef()

    const [clickManagerSignup, enterManagerLogin] = useManagerLogin(idRef, pwRef)

    return (
        <Style.Wrapper>
            <Style.ContentDiv>
                <h2>매니저 로그인</h2>

                <Style.FormDiv onKeyUp={enterManagerLogin}>
                    <DefaultInput label="아이디" inputRef={idRef} placeholder="아이디를 입력해주세요." />
                    <DefaultInput label="비밀번호" type="password" inputRef={pwRef} placeholder="비밀번호를 입력해주세요." />
                </Style.FormDiv>

                <Style.BtnDiv>
                    <Style.AdminLoginBtn onClick={() => navigate("/login/admin")}>혹시 서비스 관리자 이신가요?</Style.AdminLoginBtn>
                    <DefaultButton clickEvent={clickManagerSignup}>로그인</DefaultButton>
                    <DefaultButton clickEvent={() => navigate("/signup/manager")} minor>회원가입</DefaultButton>
                    <Style.ControlDiv>
                        <button onClick={() => navigate("/find/manager/id")}>아이디 찾기</button>
                        <button onClick={() => navigate("/find/manager/password")}>비밀번호 찾기</button>
                    </Style.ControlDiv>
                </Style.BtnDiv>

            </Style.ContentDiv>
        </Style.Wrapper>
    )
}

export default LoginManager